const tresaTopics = [
  {
    type: "tresa topic",
    id: "SRP",
    title: "Self Represented Party",
    text: `<p>
    A consumer or prospective client that is asking general questions about
    the real estate market is not a Self-Represented Party, unless they
    declare as such. You will only encounter an SRP in a trade when you are
    already representing either a Buyer or Seller. Agents are prohibited
    from providing services, opinions, or advice to an SRP (price, terms,
    clauses to include in an offer...etc.).</p>
  <br />
  <h1>What is a Self Represented Party (SRP)</h1>
  <ol>
    <li>A person who is not a client of a brokerage</li>
    <li>Any person who is representing their own interests in a real estate trade</li>
  </ol>
  <br />
  <p>
    You should not provide SRPs with your judgements, opinions, services, skill and 
    advice. Be careful not to act in a way that creates implied representation.
  </p>
  <br />
  <p>You can only provide <strong> Assistance</strong> to a Self-Represented Party.</p>
  <br />
  <h1>What is Assistance?</h1>
  <p>
    The ability to provide assistance will only exist if you already have a client 
    in a trade. You are prohibited from providing services, opinions or advice to 
    the party receiving assistance. Additionally, you can only provide assistance 
    if that assistance is in the best interests of your client.
    <br />
    <br />
    Examples:
    <ol>
      <li>A Buyer shows interest in viewing your Seller client's property</li>
      <li>A Buyer client wants to put in an offer on a For Sale By Owner property</li>
      <li>A Buyer, who declares themselves as an SRP, wants to put in an offer on 
      your Seller client's property</li>
    </ol>
  </p>
  <br />
  <p>
  <strong>If an SRP declares themselves as Self-Represented, certain steps must be taken 
  in order for you to be able to provide Assistance.</strong>
  <br /><br /></p>
  <ol>
    <li><strong>Verify they want to be an SRP </strong> and do not want the benefits 
    of representation</li>
    <li>Provide the <strong> RECO Information Guide</strong></li>
    <li>Provide the <strong>RECO Information and Disclosure to Self-Represented Party Form
      </strong>
    </li>
    <li>Make it clear to the SRP that you represent the best interests of your client
    </li>
    <li>Make best efforts to obtain acknowledgement of the Guide & Disclosure Form</li>
  </ol>
  <br />
  <p>
    For more information, please view the
    <a
      href="https://reco.on.ca/getmedia/1c4f93f7-ccea-490f-9e10-26f9998c8465/RECO-Bulletin-2-4-Dealing-with-a-self-represented-party.pdf"
      target="_blank"
      rel="noreferrer"
    >
      RECO Bulletin 2.4: Dealing with a Self-Represented Party
    </a>
  </p>`,
  },
  {
    type: "tresa topic",
    id: "DesigRepForms",
    title: "Designated Representation Forms",
    text: `<p>
    Since eXp operates under the Designated Representation Model, we must
    use forms that allow for the insertion of a designated representative.
    By extending representation to the named agent(s) in the agreement, this
    model helps reduce occurrences of Multiple Representation.
  </p>
  <br />
  <h1>Forms for Designated Representation</h1>
<br/>
  <ol>
    <li>
      <strong>FORM 271:</strong> Listing Agreement – Seller Designated
      Representation Agreement Authority to Offer for Sale
    </li>
    <li>
      <strong>FORM 272:</strong> Listing Agreement – Landlord Designated
      Representation Agreement Authority to Offer for Lease
    </li>
    <li>
      <strong>FORM 371:</strong> Buyer Designated Representation Agreement –
      Authority for Purchase or Lease
    </li>
    <li>
      <strong>FORM 372:</strong> Tenant Designated Representation Agreement
      – Authority for Lease or Purchase
    </li>
  </ol>
  <br />
  <p>
    <strong>Please do not use FORMS 200, 210, 300, 346</strong> as they are
    not suitable for the Designated Representation Model.
  </p>`,
  },
  {
    type: "tresa topic",
    id: "RECOGuide",
    title: "RECO Information Guide",
    text: `<p>
    It is important to note that ALL consumers seeking your Judgements,
    Opinions, Services, Skills or Advice (JOSSA) must be provided the RECO
    Information Guide, as a first step. This guide, as per RECO, cannot be
    altered or personalized.
  </p>
  <br />
  <p>
    <strong>Important:</strong> Under TRESA - no person can receive
    judgements, opinions, skills, services or advice (JOSSA) without a
    representation agreement.
  </p>
  <br />
  <div>
    <h2>The RECO Information Guide should be:</h2>
    <ol>
      <li>
        <strong>Shared with the Consumer:</strong> Ensure you have proof it
        was sent to the consumer.
      </li>
      <li>
        <strong>Explained to the Consumer:</strong> Allows them to make an
        informed decision with regards to their options.
      </li>
      <li>
        <strong>Acknowledged:</strong> Obtain signed acknowledgement (last
        page)
      </li>
    </ol>
    <br />
    <p>
      Assistance can only be provided to consumers, if the assistance
      provided benefits YOUR client. Hence, you cannot provide assistance to
      anyone if you do not have a client involved in the trade. (example:
      showing a consumer your clients' listing is acceptable after guide
      obligations are fulfilled).
    </p>
  </div>
  <br />
  <div>
    <h2>Where do I find the RECO INFO GUIDE?</h2>

    <p>
      Visit:
      <a
        href="https://www.recoinfoguide.ca/"
        target="_blank"
        rel="noreferrer"
      >
        www.recoinfoguide.ca</a>
       to either download the RECO Info Guide or use their online tool to
      send to the consumer.
    </p>
    <br />
    <p>
      <strong>Please note:</strong> if you use the online tool, you will
      need 2 emails in order to fulfill your obligations.
    </p>
    <br />
    <p>
      <strong>Email 1:</strong> Guide Shared
    </p>
    <br />
    <p>
      <strong>Email 2: </strong>Guide Acknowledged. This is obtained after
      the consumer checks the box at the end of the guide and submits.
    </p>`,
  },
  {
    type: "tresa topic",
    id: "MultiRep",
    title: "Multiple Representation",
    text: `<p>
    Since eXp is operating under the
    <strong>“Designated Representation Model”</strong>. As a result,
    multiple representation can only arise in the following instances:
  </p>
  <br />
  <ol>
    <li>
      You are the designated representative for both Buyer/Tenant and
      Seller/Landlord in the same trade
    </li>
    <p>OR</p>
    <li>
      You are the designated representative for more than one Buyer/Tenant
      in the same trade
    </li>
  </ol>
  <br />
  <p>
    If multiple representation is discovered to be a possibility in a
    specific trade, this must be disclosed to both Buyer/Tenant and
    Seller/Landlord at the time of it arising.
  </p>
  <br />
  <p>
    You cannot proceed with the trade until ALL parties have given written
    consent to allow multiple representation. This consent is obtained with
    2 documents (One for the Buyer/Tenant, One for the Seller/Landlord):
  </p>
  <br />
  <ol>
    <li>
      <strong>FORM 325 </strong> – Multiple Representation, Seller –
      Acknowledgement & Consent Disclosure <br />
      OR <br />
      <strong>FORM 327 </strong> – Multiple Representation, Landlord –
      Acknowledgement & Consent Disclosure
    </li>
    <br />

    <li>
      <strong>FORM 326</strong> - Multiple Representation, Buyer –
      Acknowledgement & Consent Disclosure <br />
      OR <br />
      <strong>FORM 328 </strong> – Multiple Representation, Tenant –
      Acknowledgement & Consent Disclosure
    </li>
  </ol>
  <br />
  <p>
    If parties do not agree to multiple representation, the designated
    representative must either:
  </p>
  <br />
  <ol>
    <li>Release one client/or not sign a representation agreement</li>
    <p>OR</p>

    <li>Refer one of the parties to another agent</li>
  </ol>
  <br />

  <p>
    <strong>Important:</strong> These documents should be signed in a
    separate signing from any other documents to ensure a separate
    conversation took place.
  </p>
  <br />
  <p>
    For more information, please view the
    <a
      href="https://www.reco.on.ca/getmedia/388e0f8a-7943-4ee6-88ae-28970c29f1e1/RECO-Bulletin-3-2-Multiple-representation.pdf"
      target="_blank"
      rel="noreferrer"
    >
      RECO Bulletin 3.2: Multiple Representation
    </a>
  </p>`,
  },
  {
    type: "tresa topic",
    id: "ScheduleA",
    title: "Schedule A in Agreements",
    text: ` <p>
    Schedule A is mandatory for all Agreements and is required to
    include a list of services to be provided to the client.
  </p>
  <br />
  <h1>Why?</h1>

  <ol>
    <li>TRESA stresses the importance of transparency to your clients</li>
    <li>
      They add a level of professionalism and commitment to your clients
    </li>
    <li>
      It’s a great way to showcase all the amazing services you will provide
      to your clients
    </li>
    <li>
      Added value of a detailed Schedule A will put you above the
      competition
    </li>
  </ol>
  <br />
  <p>
    Ensure that the services you outline for your client in Schedule A are
    communicated clearly and plainly. Over time, this document is likely to
    change as you incorporate additional services into your business model.
    Remember to adhere to the "under promise and over deliver" model when
    committing to performing all listed services for your client.
  </p>
  <br />
  <p>
    For more information, please see our
    <a
      href="https://drive.google.com/drive/folders/1oX3MHYX704qW41v0NjHNm1OhUC4B-3J5"
      target="_blank"
      rel="noreferrer"
    >
      List of Potential Client Services
    </a>
  </p>`,
  },
  {
    type: "tresa topic",
    id: "Lockboxes",
    title: "Lockbox Authorization & Consent",
    text: `<p>
    As per TRESA, Sellers must give written consent in order for the use and
    installation of lockboxes. Some boards have mandatory forms that deal
    with lockbox authorization, some do not. If your board does not have a
    form that deals with the consent and authorization for lockboxes, a
    clause should be inserted into Schedule A so that consent is obtained.
  </p>
  <br />
  <h1>Key points when complying with this regulation are:</h1>
  <ol>
    <li>
      Listing agents must have written authorization from the seller to
      place a lockbox on any property
    </li>
    <li>
      Listing agents must explain the benefits and risks of using a lockbox
    </li>
    <li>
    The seller has the authority to choose the type of lockbox to be utilized. If 
    a mechanical lockbox is selected, they must indicate how often the code will 
    be changed
    </li>
  </ol>
  <br />

  <h1>Lockbox Permission Clause for Schedule A</h1>
  <p>
    Lockbox Authorization: The Seller hereby grants permission to the
    designated representative and the brokerage to utilize a lockbox and/or
    a digital lockbox for the purpose of facilitating access to the property
    for sale, including access for showings, inspections, appraisals, final
    walk-throughs, and service providers. The Seller acknowledges that the
    designated representative and the brokerage shall use reasonable care
    and diligence in managing access to the property through the lockbox
    system. The Seller agrees to provide any necessary codes or keys
    required to operate the lockbox system promptly upon request by the
    brokerage.
  </p>
  <br />
  <p>
    Disclosure: The Seller acknowledges that the use of a lockbox and/or
    digital lockbox provides convenience and efficiency in granting access
    to the property, but may also present certain risks, including the
    potential for unauthorized access. While the brokerage will take
    reasonable measures to safeguard the property, the Seller understands
    that they assume a level of risk associated with the use of a lockbox
    system. However, it is a common practice in the real estate industry and
    facilitates efficient property showings and access. The Seller consents
    to the use of the lockbox system with this understanding.
  </p>
  <br />
  <br />
  <p>
    For more information, please view the
    <a
      href="https://www.reco.on.ca/getmedia/1da0669b-82e3-44f0-b869-31604dcaa79b/RECO-Bulletin-7-2-Lockboxes.pdf"
      target="_blank"
      rel="noreferrer"
    >
      RECO Bulletin 7.2: Lockboxes
    </a>
  </p>`,
  },
  {
    type: "tresa topic",
    id: "LatentDefects",
    title: "Disclosure of Latent Defects",
    text: `<h1>All Disclosures must be:</h1>
    <ol>
      <li>Written in plain language that is clear and concise</li>
      <li>
        Presented in a manner that draws the person’s attention to the
        required information
      </li>
    </ol>
    <p>
      Failing to disclose latent defects may be considered misrepresentation
    </p>
    <br />

    <h1>
      FORM 299 is to be signed by both Buyers and Sellers before an offer
    </h1>
    <p>
      See the
      <a href="/ON/common-forms" rel="noreferrer">Common Forms</a>
      Section for an example of this form
    </p>
    <br />
    <p>
      The seller’s obligation to disclose and the facts or defects they must
      disclose are based on current case law, not TRESA.
    </p>
    <br />
    <p>
      <strong>A seller must disclose latent defects. </strong>An agent
      representing a seller should advise the seller to seek a legal opinion
      if there are any concerns about whether a particular defect is a latent
      defect and needs to be disclosed.
    </p>
    <br />
    <p>
      Even if a seller does not have direct knowledge of a latent defect, they
      may still be liable if they were willfully blind about the existence of
      the defect.
    </p>
    <br />
    <br />
    <p>
      For more information, please view the following RECO Bulletins: <br />
      <a
        href="https://www.reco.on.ca/getmedia/d0f700bd-5848-4edb-a9f5-a35040ec2b20/RECO-Bulletin-7-3-Material-facts.pdf"
        target="_blank"
        rel="noreferrer"
      >
        RECO Bulletin 7.3: Material Facts
      </a>
      <br />
      <a
        href="https://www.reco.on.ca/getmedia/289a3791-b19d-4cd4-817e-2d664b300257/RECO-Bulletin-7-4-Facts-a-seller-has-a-legal-obligation-to-disclose.pdf"
        target="_blank"
        rel="noreferrer"
      >
        RECO Bulletin 7.4: Facts a seller has a legal obligation to disclose
      </a>
      <br />
      <a
        href="https://www.reco.on.ca/getmedia/fad5fc94-b611-41e0-80ad-9e4fa325f227/RECO-Bulletin-7-5-Stigmas.pdf"
        target="_blank"
        rel="noreferrer"
      >
        RECO Bulletin 7.5: Stigmas
      </a>
    </p>`,
  },
  {
    type: "tresa topic",
    id: "OpenHouses",
    title: "Open Houses",
    text: ` <p>
    Only the seller’s designated representative(s) represents the seller’s
    best interest and is permitted to have access to the seller’s
    confidential client information. If the agent hosting the open house is
    not the seller’s designated representative, the hosting agent must make
    it clear to attendees they do not represent the seller of the property.
  </p>
  <br />
  <p>
    If the Seller’s Designated Representative is unable to or chooses not to
    host the open house, the Seller essentially has 3 options:<br/><br/>
    <ol>
      <li>
        The seller can provide consent for another agent from the seller’s
        brokerage, who does not represent the seller’s best interests, to
        host the open house.
      </li>
      <li>
        The seller can consent to adding another brokerage agent as a
        designated representative to the Agreement for the purposes of the
        open house.
      </li>
      <li>
        The seller can postpone the open house for a time when their
        designated representative is available.
      </li>
    </ol>
  </p>
  <br />

  <p>
    If #1 is chosen, discuss this with the agent that will be doing the open
    house:
    <br />
    The hosting agent must ensure that they provide only public factual information 
    regarding the property and the real estate market. They should refrain from 
    offering advice or opinions about the property to attendees they do not 
    represent, or those who may be represented by another agent or brokerage.
  </p>
  <br />
  <h1>
    This clause can be added to Schedule A in the Listing Agreement (as an
    option):
  </h1>
  <p>
    The Seller gives permission for an alternative eXp Realtor to host an
    open house, as needed and agreed upon between the listing designated
    representative and the Seller. The Seller understands and agrees that
    the alternative eXp Realtor would not be representing the seller’s best
    interest during the open house but only providing secure access to the
    property and providing factual information regarding the property and
    the real estate market in general. Further, the alternative agent is
    unable to provide opinions or share advice with the open house
    attendees.
  </p>
  <br />

  <p>
    The seller’s written direction for the open house must include:<br/><br/>
    <ol>
      <li>the date, start time, and end time of the open house</li>
      <li>the name of the agent(s) hosting the open house</li>
      <li>any restrictions related to access during the open house</li>
    </ol>
    <br />
    <p>This can be achieved by completing FORM 208</p>
  </p>
  <br />
  
  <p>
    For more information, please view the
    <a
      href="https://reco.on.ca/getmedia/6c521f6d-6bc8-4338-9114-4748e1f2e2fe/RECO-Bulletin-7-6-Hosting-an-open-house.pdf"
      target="_blank"
      rel="noreferrer"
    >
      RECO Bulletin 7.6: Hosting an Open House
    </a>
  </p>`,
  },
  {
    type: "tresa topic",
    id: "SharingContent",
    title: "Sharing Content of Offers",
    text: `<p>
    3 key points to remember:
    <br /><br/>
    <ol>
      <li>The number of competing offers must be communicated to all</li>
      <li>
        If the Seller chooses to share contents of the offers, this
        information must be shared with all of those who made an offer
      </li>
      <li>Personal information must not be shared</li>
    </ol>
    <br />
    <p>The Seller can choose to share all or select parts of the offers.
    <br />
    <br />
    The Sellers written direction must be obtained. In order to share, a
    <strong>
      
      FORM 209: Seller Direction to Share Substance of Offers
    </strong>
    must be completed.</p>
  </p>
  <br />
  <p>
    If the Seller’s direction changes at any time, a new FORM 209 must be
    completed and communicated to all parties that have made an offer.
  </p>
  <br />
  <p>
    If you are working with a Buyer that wishes to back out if the contents
    are being shared, you must include the following:<br/><br/>
    <ol>
      <li>OREA Clause DISC-1 in the APS</li>
      <li>Submit FORM 108: Notice of Revocation</li>
    </ol>
  </p>
  <br />
  <p>
    For more information, please view the
    <a
      href="https://reco.on.ca/getmedia/904af08d-acc5-4f49-8c49-ffce4848578c/RECO-Bulletin-4-1-Number-and-content-competing-offers.pdf"
      target="_blank"
      rel="noreferrer"
    >
      RECO Bulletin 4.1: Number and content of competing offers
    </a>
  </p>`,
  },
];

export default tresaTopics;
